module.exports = __webpack_public_path__ + "static/img/2dd7a2d09fa94bf8b5c52e5318868b4d9.21ddee35.jpg";